var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHbA1CIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#5A68E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.526 17.5391C21.6541 17.5391 21.7767 17.5915 21.8651 17.6842C21.9456 17.7685 23.8359 19.7708 23.8359 21.6896C23.8359 22.9632 22.7997 23.9994 21.526 23.9994C20.2525 23.9994 19.2164 22.9632 19.2164 21.6895C19.2164 19.7708 21.1065 17.7684 21.1869 17.6842C21.2754 17.5915 21.3979 17.5391 21.526 17.5391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0265 16.4688H16.2848C17.5356 16.5174 17.5349 18.3054 16.2848 18.3542H14.0265C12.7812 18.3061 12.771 16.5206 14.0265 16.4688Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0265 19.293H16.2848C17.5357 19.3417 17.5349 21.1296 16.2848 21.1784H14.0265C12.7806 21.1302 12.7716 19.3445 14.0265 19.293Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0604 13.6446C24.3098 13.6948 24.3114 15.4804 23.0604 15.53H14.027C13.6904 15.53 13.3676 15.6182 13.0843 15.7828V13.9332L13.3702 13.6445H23.0604V13.6446Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0265 22.1133H16.2849C17.5356 22.162 17.5349 23.9499 16.2849 23.9987H14.0265C12.7812 23.9506 12.771 22.1651 14.0265 22.1133Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3667 8.13722C14.4602 8.04372 14.5786 8 14.6957 8C15.3998 8 15.694 9.97263 14.5318 11.1466L12.2829 13.4118C12.196 13.4996 12.1473 13.6182 12.1473 13.7417V16.0006C12.1473 17.2983 11.0914 18.3542 9.79367 18.3542C9.53479 18.3542 9.32464 18.564 9.32464 18.8229C9.32464 19.0818 9.53423 19.2917 9.7931 19.2917C10.7924 19.2917 11.6889 18.8441 12.293 18.1392C12.441 18.4916 12.6595 18.7111 12.786 18.8228C11.9387 19.5482 11.9374 20.9188 12.786 21.6457C12.1101 22.2258 11.9544 23.2493 12.4004 23.9999H7.94623C7.43429 23.9999 7.00351 23.5856 7.00351 23.0569V14.5004L14.3667 8.13722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbA1CIcon);
export default __webpack_public_path__ + "static/media/hbA1c-icon.ecac3a259f1f40abaadb9ed3edb14bdf.svg";
export { ForwardRef as ReactComponent };